query GetNewsItemTypes {
  newsItemTypes {
    id
    name
  }
}
